import { getEditorString, getPointBefore, getRange } from '@udecode/plate';
import { BufferEditor } from '~/editor/BufferEditor/types.plate';

export const isPreviousCharacterWhitespaceOrStart = (
  editor: BufferEditor
): boolean => {
  if (!editor.selection) return false;

  const previousChar = getEditorString(
    editor,
    getRange(editor, editor.selection, getPointBefore(editor, editor.selection))
  );
  return previousChar === '' || previousChar === ' ';
};
